import React from 'react';
import Pencil from '@uber/base-icons/pencil';
import { useStyletron } from 'baseui';
import { ICON_SIZE } from '../constants';
import type { ActionButtonPropsT } from '../types';
import { ActionButton } from './action-button';
export function EditButton({
  onClick
}: ActionButtonPropsT) {
  const [, theme] = useStyletron();
  return <ActionButton icon={<Pencil size={ICON_SIZE} color={theme.colors.contentPrimary} />} name="Edit Annotation" onClick={onClick} tooltipContent="Edit Annotation" />;
}